import React, { useEffect } from 'react'
import NoRecordFoundVideo from '../../assets/Video/NoRecordFound.mp4'

const NoRecordFound = () => {

  return (
    <>
    {/* <video autoPlay loop muted height={200} width={200}>
    <source src={NoRecordFoundVideo} type='video/mp4' />
    </video> */}
     No Record Found 
    </>
  )
}

export default React.memo(NoRecordFound)